import FilesService from "../Services/FileListService.ts";

export const handleFetchFiles = async (dataset_id: number, skip = 0, limit = 10, page = 1): Promise<any> => {
  try {
    const response = await FilesService.fetchFiles(dataset_id, skip, limit, page);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching File list:", error);
    throw new Error("Failed to fetch Files");
  }
};

export const handleFetchValidFiles = async (): Promise<any> => {
  try {
    const response = await FilesService.fetchValidFiles();
    return response.data;
  } catch (error: any) {
    console.error("Error fetching File list:", error);
    throw new Error("Failed to fetch file");
  }
};

export const handleDeleteFiles = async (datasetId: number): Promise<void> => {
  try {
    await FilesService.deleteFiles(datasetId);
  } catch (error: any) {
    console.error("Error deleting dataset:", error);
    throw new Error(error.response?.data?.detail || "Failed to delete dataset");
  }
};

export const handleDownloadErrorFiles = async (filePath: string): Promise<any> => {
  try {
    const response = await FilesService.DownloadError(filePath);
    return response.data;
  } catch (error: any) {
    console.error("Error downloading file:", error);
    throw error;
  }
};
export const handleFetchFileView = async (file_id: number): Promise<any> => {
  try {
    const response = await FilesService.fetchFileView(file_id);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching file view:", error);
  }
};
export const handleAddFiles = async (dataset_id: number, files: File[]): Promise<any> => {
  try {
    const formData = new FormData();
    
    // Append each file to FormData
    files.forEach((file) => {
      formData.append('files', file);
    });

    const response = await FilesService.addFiles(dataset_id, formData);
    return response.data;
  } catch (error: any) {
    console.error("Error adding files:", error);
    if (error.response) {
      throw error;
    } else {
      throw new Error("Failed to add files");
    }
  }
};

export const handleNullAnalysis = async (file_id: number): Promise<any> => {
  try {
    const response = await FilesService.fetchNullAnalysis(file_id);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching File list:", error);
    throw new Error("Failed to fetch Files");
  }
};

export const handlePreProcessing = async (file_id: number, config: object): Promise<any> => {
  try {
    const response = await FilesService.handlePreProcess(file_id, config);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching File list:", error);
    throw new Error("Failed to fetch Files");
  }
};